import { WarningRounded } from '@mui/icons-material';
import { PRICE_FACTOR } from '../../../../../shared/constants';
import { Nullable } from '../../../../../shared/types';
import { Box } from '@mui/system';
import DefaultTooltip from '../../Tooltips/DefaultTooltip';

interface PriceRendererProps {
  value: string;
  minPrice: Nullable<number>;
  contractPrice?: Nullable<number>;
}
const PriceRenderer: React.FC<PriceRendererProps> = ({
  value,
  minPrice,
  contractPrice,
}) => {
  return (
    <Box sx={{ display: 'flex' }}>
      {value ? value + ' €' : 0 + ' €'}
      <Box
        sx={{
          display: 'flex',

          mt: 0.5,
        }}
      >
        {contractPrice &&
        contractPrice / PRICE_FACTOR < Number(value) ? (
          <DefaultTooltip title="Sopimushinta on edullisempi kuin tarjoushinta">
            <WarningRounded sx={{ fontSize: 18 }} color={'error'} />
          </DefaultTooltip>
        ) : (
          ''
        )}
      </Box>
      <span style={{ color: 'black' }}>
        {minPrice ? ' (min. ' + minPrice / PRICE_FACTOR + '€)' : ''}
      </span>
    </Box>
  );
};

export default PriceRenderer;
